import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Row, Col, message } from "antd";
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Typography } from "antd";
import './Login.css'
import logo from '../../assets/images/logo.png';
import axios from 'axios';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

const { Title } = Typography;
const LoginForm = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectParam = encodeURIComponent(searchParams.get('redirect'));
  const createURLWithParams = (url, params) => {
    if (params.length === 0) {
      return url;
    }

    const queryString = params.map((param) => `${param.key}=${param.value}`).join('&');
    return `${url}?${queryString}`;
  };
  const onFinish = async (values) => {
    await axios.get("/sanctum/csrf-cookie")

    await axios.post('/login',values)
    .then(res=>{
      props.login({...res.data,...{groupPermission:res.data.group_permission}})
      let params = []
      if(redirectParam !== '' && redirectParam !== 'null' ){//有轉址
        params.push({
          key: 'redirect',
          value: encodeURIComponent(searchParams.get('redirect'))
        });
      }

      props.history.push(createURLWithParams('/',params))
    }).catch(function(err){
      if(err.response?.status === 401){
        let error_code = err.response.data.error
        console.error(error_code)
        error('帳號密碼錯誤或非可登入狀態，詳細錯誤:'+ error_code.error)
      }else{
        error('系統錯誤')
        console.error('系統錯誤',err)
      }
    })
  };


  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };


  return (
    <div className="login-page">
      {contextHolder}
      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col span={24}>

          <Card style={{ width: '320px', backgroundColor: 'rgba(51,51,51,0.9)' , border:'0' }}>
            <div style={{ display: "flex", justifyContent: "center", padding:'10px' }}>
              <Title level={2}> <img style={{ maxWidth: '100%' }} src={logo} alt="翰可能源股份有限公司" /></Title>
            </div>
            <Form
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="name"
                rules={[{ required: true, message: "請輸入帳號" }]}
              >
                <Input
                  style={{ borderColor: '#333333', boxShadow: '0 0 5px rgba(0, 0, 0, 0)' }}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Username"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "請輸入密碼" }]}
              >
                <Input.Password
                  style={{ borderColor: '#333333', boxShadow: '0 0 5px rgba(0, 0, 0, 0)' }}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  block
                  style={{ backgroundColor: '#F23E30', borderColor: '#ff0000', boxShadow: '0 0 5px rgba(0, 0, 0, 0)' }}
                >
                  登入
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps= {
  login(payload){
    return {
      type: 'login',
      payload
    }
  }
}

export default connect(null ,mapDispatchToProps)(LoginForm);
